import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NotificationSoundHelper {

    private notes = [523.25, 659.25]; // C5 e E5

    play() {
        try {
            const audioContext = new AudioContext();
            const now = audioContext.currentTime;

            this.notes.forEach(freq => {
                const oscillator = audioContext.createOscillator();
                const gainNode = audioContext.createGain();

                oscillator.type = 'sine';
                oscillator.frequency.value = freq;

                gainNode.gain.setValueAtTime(0.2, now);
                gainNode.gain.exponentialRampToValueAtTime(0.01, now + 0.5);

                oscillator.connect(gainNode);
                gainNode.connect(audioContext.destination);

                oscillator.start(now);
                oscillator.stop(now + 0.5);
            });
        } catch {
            // do nothing
        }
    }
}
